import { Separator } from "@fluentui/react";
import React from "react";

const Divider = () => {
  return (
    <Separator styles={{ root: { height: 1, padding: 0, width: "100%" } }} />
  );
};

export default Divider;
